import { FunctionComponent, useEffect } from 'react'
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, FormHelperText, TextField, Typography } from '@mui/material'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { DialogSaveButtons } from '../../../presentation-components/miscellaneous-components/dialog-save-buttons';

export const ChangePasswordDialog: FunctionComponent<{
  open: boolean,
  closeHandler: () => void,
  submitHandler: React.Dispatch<React.SetStateAction<any>>,
  errorMessage: string,
  isSubmitting: boolean,
}> = ({
  open,
  closeHandler,
  submitHandler,
  errorMessage,
  isSubmitting,
}) => {

    const passwordSchema = Yup.object().shape({
      currentPassword: Yup.string().required('Current password is required'),
      newPassword: Yup.string().min(8, 'Your password must be at least 8 characters').required('New password is required'),
      newPasswordConfirmation: Yup.string().oneOf([Yup.ref('newPassword')], 'Passwords must match').required('You must confirm your new password'),
    })

    useEffect(() => {
      if (open) {
        formik.setValues({
          currentPassword: '',
          newPassword: '',
          newPasswordConfirmation: ''
        })
      }
    }, [open])

    const formik = useFormik({
      initialValues: {
        currentPassword: '',
        newPassword: '',
        newPasswordConfirmation: '',
      },
      validationSchema: passwordSchema,
      onSubmit: (values) => {
        submitHandler(values)
      }
    });

    return (
      <Dialog open={open} onClose={closeHandler} maxWidth='xs'>
        <Box sx={{ p: 4 }} component='form' onSubmit={formik.handleSubmit}>
          <DialogTitle sx={{ pt: 0, pl: 0, pr: 0 }}>
            Change Password
          </DialogTitle>
          <DialogContent sx={{ pt: 0, pl: 0, pr: 0 }}>
            <Typography variant='body1'>Please enter your current password</Typography>
            <TextField id='currentPassword' name='currentPassword' label='Current Password' type='password'
              fullWidth
              value={formik.values.currentPassword}
              onChange={formik.handleChange}
              error={formik.touched.currentPassword && Boolean(formik.errors.currentPassword)}
              helperText={formik.touched.currentPassword && formik.errors.currentPassword}
              sx={{ mt: 2 }} />
            {errorMessage &&
              <FormHelperText sx={{ color: "#bf3333", mt: 1 }}>{errorMessage}</FormHelperText>
            }
          </DialogContent>
          <DialogContent sx={{ pt: 0, pl: 0, pr: 0 }}> <Typography>Please enter your new password</Typography>
            <TextField id='newPassword' name='newPassword' label='New Password' type='password'
              fullWidth
              value={formik.values.newPassword}
              onChange={formik.handleChange}
              error={formik.touched.newPassword && Boolean(formik.errors.newPassword)}
              helperText={formik.touched.newPassword && formik.errors.newPassword}
              sx={{ mt: 2 }} />
            <TextField id='newPasswordConfirmation' name='newPasswordConfirmation' label='Confirm New Password' type='password'
              fullWidth
              value={formik.values.newPasswordConfirmation}
              onChange={formik.handleChange}
              error={formik.touched.newPasswordConfirmation && Boolean(formik.errors.newPasswordConfirmation)}
              helperText={formik.touched.newPasswordConfirmation && formik.errors.newPasswordConfirmation}
              sx={{ mt: 2 }} />
          </DialogContent>
          <DialogActions sx={{ p: 0 }}>
            <DialogSaveButtons
              cancelHandler={closeHandler}
              submitHandler={formik.submitForm}
              isSubmitting={isSubmitting}
            />
          </DialogActions>
        </Box>
      </Dialog>
    )
  }